import React from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Button,
} from '@mui/material';
import { Menu as MenuIcon, Logout as LogoutIcon } from '@mui/icons-material';
import { useAuth } from '../../context/AuthContext';
import { DRAWER_WIDTH } from './Sidebar';
import IgvSettings from './IgvSettings';

interface TopBarProps {
  onMenuClick: () => void;
  isMobile: boolean;
}

const TopBar: React.FC<TopBarProps> = ({ onMenuClick, isMobile }) => {
  const { user, logout } = useAuth();

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        width: isMobile ? '100%' : `calc(100% - ${DRAWER_WIDTH}px)`,
        ml: isMobile ? 0 : `${DRAWER_WIDTH}px`,
        backgroundColor: '#FFFFFF',
        borderBottom: '1px solid #E5E7EB',
      }}
    >
      <Toolbar>
        {isMobile && (
          <IconButton onClick={onMenuClick} edge="start" sx={{ mr: 2, color: '#374151' }}>
            <MenuIcon />
          </IconButton>
        )}
        <Typography variant="h6" sx={{ flexGrow: 1, color: '#111827', fontWeight: 600 }}>
          {/* Page title handled by each page */}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography variant="body2" sx={{ color: '#6B7280', display: { xs: 'none', sm: 'block' } }}>
            {user?.fullName} ({user?.role})
          </Typography>
          {user?.role === 'admin' && <IgvSettings />}
          <Button
            startIcon={<LogoutIcon />}
            onClick={logout}
            size="small"
            sx={{ color: '#6B7280', textTransform: 'none' }}
          >
            Salir
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
